// The built-in default Order Invite text (PR 1.3). One source of truth shared
// by the sms-jobs invite_rotation worker (which uses it when a store has no
// sms_invite_rotations.invite_message_body) and the app's invite-text editor
// (which shows it as the starting/placeholder value via the smsShared
// re-export). Import-free so both the edge runtime and the Vite app can use it.
//
// Satisfies IR-5 by construction: it names the business ({location_name}) and
// carries the STOP opt-out line.
export const DEFAULT_INVITE_MESSAGE_BODY =
  "Hey, it's {location_name}: Join our text club! Reply Y for a welcome offer & ongoing deals. Reply STOP to opt out.";

/** How many past customers one backlog-sweep batch invites (~150/weekday). */
export const DEFAULT_BACKLOG_BATCH_SIZE = 150;
